import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import ColourCubes, { ColourCubesSupport } from "@/pages/ColourCubes";
import StudioCatalogue from "@/pages/StudioCatalogue";
import ColourCubesPrivacy from "@/pages/ColourCubesPrivacy";
import { Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ForgotAI from "@/pages/ForgotAI";
import { ForgotPrivacy, ForgotTerms, ForgotSupport } from "@/pages/ForgotLegal";
import LegalHub from "@/found/LegalHub";
import Privacy from "@/found/Privacy";
import Terms from "@/found/Terms";
import Community from "@/found/Community";
import Copyright from "@/found/Copyright";
import DeleteAccount from "@/found/DeleteAccount";
import Support from "@/found/Support";

function ScrollToDestination() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
      else window.scrollTo(0, 0);
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToDestination />
      <Routes>
        <Route path="/games" element={<StudioCatalogue kind="games" />} />
        <Route path="/apps" element={<StudioCatalogue kind="apps" />} />
        <Route path="/colour-cubes" element={<ColourCubes />} />
        <Route path="/colour-cubes/support" element={<ColourCubesSupport />} />
        <Route path="/colour-cubes/privacy-policy" element={<ColourCubesPrivacy />} />
        <Route path="/forgot-ai/privacy-policy" element={<Navigate replace to="/forgot-ai/privacy" />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/forgot-ai" element={<ForgotAI />} />
        <Route path="/forgot-ai/privacy" element={<ForgotPrivacy />} />
        <Route path="/forgot-ai/terms" element={<ForgotTerms />} />
        <Route path="/forgot-ai/support" element={<ForgotSupport />} />
        <Route path="/found/legal" element={<LegalHub />} />
        <Route path="/found/privacy" element={<Privacy />} />
        <Route path="/found/terms" element={<Terms />} />
        <Route path="/found/community-guidelines" element={<Community />} />
        <Route path="/found/copyright" element={<Copyright />} />
        <Route path="/found/delete-account" element={<DeleteAccount />} />
        <Route path="/found/support" element={<Support />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
